<template>
    <InfoBox title="Flash content" :variant="variant" button="Clear file">
        <div class="px-5">
            <p v-if="this.modelValue">
                <strong>Image loaded: {{ this.modelValue.data.length }} Bytes</strong>
                <p>SHA-1: {{ this.modelValue.shasum }}<br/>Loaded: {{ this.modelValue.timestamp.toLocaleString() }}</p>
                <p>
                    <span v-if="this.modelValue.partial">Partial image &middot;</span>
                    Source:
                    <span v-if="this.modelValue.isFromFile()">File</span>
                    <span v-else-if="this.modelValue.isFromDump()">Flash</span>
                    
                </p>
            </p>
            <p v-else>
                <strong>No image loaded.</strong><br/>
                <p>
                    Click "Read" to load the current content of the flash. This data is used to determine which parts have to be updated (erased & written) when you write the flash. Otherwise, the flash contents will be read once you hit write.
                </p><br/>
                <p>If you already know the current contents you can load them below - this will avoid performing a full read before writing the flash.</p><br/>
            </p>
            <p>
                <button v-if="this.modelValue" class="underline pr-4" @click="downloadFile">Download</button>
                <button class="underline" @click="loadImageFromFile">Load contents from file</button>
            </p>
        </div>
    </InfoBox>
</template>

<script>
import { formatMemorySize, buf2hex, downloadUint8ArrayAsBin } from "../flash/util"
import InfoBox from "./InfoBox.vue";
import {getFileAsUint8Array } from "../Util"
import { DataSource, FlashContents } from "../flash/FlashContents";
export default {
  components: {
      InfoBox,
  },
  data() {
    return {
        shasum: null
    };
  },
  props: {
    flash: {
        type: Object,
        required: true
    },
    modelValue: {
        type: Object,
        required: true
    }
  },
  computed: {
    variant() {
        if(this.modelValue) {
            return "green";
        } else {
            return "dark";
        }
    },
    size() {
      if (!this.flash) return 0;
      return formatMemorySize(this.flash.getCapacity() * 8);
    }
  },
  methods: {
    async downloadFile() {
        downloadUint8ArrayAsBin("flash.bin", this.modelValue.data);
    },
    async loadImageFromFile() {
        const fileContents = await getFileAsUint8Array();
        if(fileContents) {
            console.log("Loaded file")
            const fc = await FlashContents.createFromData(fileContents, false, DataSource.File);
            this.$emit("update:modelValue", fc);
        }
    }
  },
//   watch: {
//     modelValue() {
//         console.log("Flash data updated")
//         if(!this.modelValue) {
//             this.shasum = null;
//             return;
//         }
//         crypto.subtle.digest("SHA-1", this.modelValue).then((hashBuffer) => {
//             const hashArray = new Uint8Array(hashBuffer);
//             this.shasum = buf2hex(hashArray)
//         })
//     }
//   }
};
</script>

<style scoped>
/* Table styling */

td,th {
  text-align: left;
}

</style>
